import React, { useEffect } from "react";
import { tabsProps } from "../../../../components/Tabs";
import { useLocation, useNavigate } from "react-router-dom";
import CustomRoutes from "../../../../components/Routes/CustomRoutes";
import PayGroup from "./PayGroup";
import PayGroupDetails from "./PayGroup/index";

const PayGroupRoutes = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [activeParent] = React.useState<string>(location.pathname);

    const subRoutes: tabsProps[] = [
        { key: 'list', label: '', content: <PayGroup /> },
        { key: 'list/details/:id', label: '', content: <PayGroupDetails /> }
    ]

    useEffect(() => {
        if (activeParent) {
            navigate(`${activeParent}/${subRoutes[0].key}`, { replace: true });
        }
    }, []);

    return <>
        <CustomRoutes routes={subRoutes} />
    </>
}

export default PayGroupRoutes;